import { render, staticRenderFns } from "./Factured.vue?vue&type=template&id=1fde19a8&"
import script from "./Factured.vue?vue&type=script&lang=js&"
export * from "./Factured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../var/www/transport-app/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports